import { Skeleton } from './skeleton';

export function SkeletonTroedelItem({ testid = 'skeleton-troedel-item' }) {
  return (
    <div data-testid={testid} className="bg-[var(--bg-L1)] border border-[var(--border-default)] rounded-2xl overflow-hidden">
      <Skeleton className="aspect-[4/3] w-full rounded-none" />
      <div className="p-3 space-y-2">
        <Skeleton className="h-4 w-3/4 rounded" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-12 rounded" />
          <Skeleton className="h-4 w-16 rounded-full" />
        </div>
      </div>
    </div>
  );
}
